// src/runtime/lazy/context.ts
import {
  createContext
} from "react";
var LazyContext = createContext(void 0);

export {
  LazyContext
};
